import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Badge, useLocalizeMessage, Dropdown } from 'libs.nucleus';
export const useMeasuresColumns = ({ onEdit, onDelete, onClone, isEditDisabled = false, isDeleteDisabled = false, isCloneDisabled = false, isViewMode = false, }) => {
    const translate = useLocalizeMessage();
    return useMemo(() => [
        {
            header: translate('Internal name'),
            accessorKey: 'name',
            cell: ({ row }) => _jsx("div", { className: 'font-medium', children: row.original.name }),
        },
        {
            header: translate('Display name'),
            accessorKey: 'title',
            cell: ({ row }) => row.original.title || '-',
        },
        {
            header: translate('Type'),
            accessorKey: 'type',
            cell: ({ row }) => {
                const typeLabels = {
                    number: translate('Number'),
                    string: translate('Text'),
                    time: translate('Date Time'),
                };
                return typeLabels[row.original.type] || row.original.type || '-';
            },
        },
        {
            header: translate('Description'),
            accessorKey: 'description',
            cell: ({ row }) => row.original.description || '-',
        },
        {
            header: translate('Visibility'),
            accessorKey: 'isVisible',
            size: 100,
            cell: ({ row }) => (_jsx(Badge, { variant: row.original.isVisible !== false ? 'success' : 'common', label: row.original.isVisible !== false ? translate('Visible') : translate('Hidden') })),
        },
        {
            id: 'actions',
            size: 50,
            cell: ({ row }) => {
                const dropdownItems = isViewMode
                    ? [
                        {
                            id: 'view',
                            content: translate('View'),
                            onClick: () => onEdit(row.original.id),
                        },
                        {
                            id: 'clone',
                            content: translate('Clone'),
                            onClick: () => onClone(row.original.id),
                            disabled: isCloneDisabled,
                        },
                        {
                            id: 'delete',
                            content: translate('Delete'),
                            onClick: () => onDelete(row.original.id),
                            disabled: isDeleteDisabled,
                            destructive: true,
                        },
                    ]
                    : [
                        {
                            id: 'edit',
                            content: translate('Edit'),
                            onClick: () => onEdit(row.original.id),
                            disabled: isEditDisabled,
                        },
                        {
                            id: 'clone',
                            content: translate('Clone'),
                            onClick: () => onClone(row.original.id),
                            disabled: isCloneDisabled,
                        },
                        {
                            id: 'delete',
                            content: translate('Delete'),
                            onClick: () => onDelete(row.original.id),
                            disabled: isDeleteDisabled,
                            destructive: true,
                        },
                    ];
                return (_jsx("div", { className: 'flex justify-end', children: _jsx(Dropdown, { variant: 'kebab', position: 'bottom-end', items: dropdownItems }) }));
            },
        },
    ], [translate, onEdit, onDelete, onClone, isEditDisabled, isDeleteDisabled, isCloneDisabled, isViewMode]);
};
